import { generateMetricsFilterParams } from "../components/admin/analytics/utils/utils";
import { PieChartData } from "../store/reducers/admin/analytics";
import { Get } from "./helpers";

const filterParams = (start: number | undefined, end: number | undefined, audienceList: string[] | undefined) => {
	const _start = start ? new Date(start) : null;
	const _end = end ? new Date(end) : null;
	const filterParam = generateMetricsFilterParams({ start: _start, end: _end, audienceList });
	return filterParam;
};



export function GetChannelEvents(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/events${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelDeviceTypes(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/deviceTypes${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelBrowsers(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/browsers${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelAudience(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/audience${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelRegistrations(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/registrations${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelDurations(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/averageDuration${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelViews(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/views${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelWatchtime(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/watchtime${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelRetentionAverage(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/retention/average${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelRetentionBuckets(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/retention/buckets${filterParams(start, end, audienceList)}`, token);
}

export function GetChannelRegions(channel: number, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/regions${filterParams(start, end, audienceList)}`, token);
}

export function GetEventDeviceTypes(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/deviceTypes${filterParams(start, end, audienceList)}`, token);
}
export function GetEventRegions(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/regions${filterParams(start, end, audienceList)}`, token);
}
export function GetEventLanguages(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/languages${filterParams(start, end, audienceList)}`, token);
}
export function GetEventViews(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/views${filterParams(start, end, audienceList)}`, token);
}
export function GetEventDuration(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/averageDuration${filterParams(start, end, audienceList)}`, token);
}
export function GetEventRetentionAverage(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/retention/average${filterParams(start, end, audienceList)}`, token);
}
export function GetEventRetentionBuckets(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/retention/buckets${filterParams(start, end, audienceList)}`, token);
}
export function GetEventRegistrations(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/registrations${filterParams(start, end, audienceList)}`, token);
}
export function GetEventEmails(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/emails${filterParams(start, end, audienceList)}`, token);
}
export function GetEventWatchtime(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/watchtime${filterParams(start, end, audienceList)}`, token);
}
export function GetEventBrowsers(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/browsers${filterParams(start, end, audienceList)}`, token);
}
export function GetEventSessions(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/sessions${filterParams(start, end, audienceList)}`, token);
}
export function GetEventMapData(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/countryMap${filterParams(start, end, audienceList)}`, token);
}

export function GetSessionDeviceTypes(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/deviceTypes${filterParams(start, end, audienceList)}`, token);
}

export function GetSessionUserSurvey(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<PieChartData[]> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/userSurveys${filterParams(start, end, audienceList)}`, token);
}

export function GetSessionRegions(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/regions${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionLanguages(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/languages${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionViews(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/views${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionDuration(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/averageDuration${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionRetentionAverage(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/retention/average${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionRegistrations(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/registrations${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionEmails(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/emails${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionWatchtime(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/watchtime${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionBrowsers(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/browsers${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionTimeline(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/timeline${filterParams(start, end, audienceList)}`, token);
}
export function GetSessionMapData(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/countryMap${filterParams(start, end, audienceList)}`, token);
}

export function GetHighestConcurrent(uuid: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/max-concurrent${filterParams(start, end, audienceList)}`, token);
}

export function GetHighestConcurrentLang(uuid: string, lang: string, token: string, start?: number, end?: number, audienceList?: string[]): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/max-concurrent/${lang}${filterParams(start, end, audienceList)}`, token);
}